import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class FavoritePropertiesService {

  favoritePropertiesCount: BehaviorSubject<number> = new BehaviorSubject(0);
  reloadFavoritePropertiesBar: BehaviorSubject<boolean> = new BehaviorSubject(false);
  displayMaxFavCountErrorMessageDialog: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private _http: HttpClient, private _global: GlobalService) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  setFavoritesCount(updatedCount: number) {
    this.favoritePropertiesCount.next(updatedCount);
  }

  getFavoritesCount(): Observable<number> {
    return this.favoritePropertiesCount.asObservable();
  }

  setReloadFavoritePropertiesBar(reload: boolean) {
    this.reloadFavoritePropertiesBar.next(reload);
  }

  getReloadFavoritePropertiesBar(): Observable<boolean> {
    return this.reloadFavoritePropertiesBar.asObservable();
  }

  setDisplayMaxFavCountErrorMessageDialog(display: boolean) {
    this.displayMaxFavCountErrorMessageDialog.next(display);
  }

  getDisplayMaxFavCountErrorMessageDialog(): Observable<boolean> {
    return this.displayMaxFavCountErrorMessageDialog.asObservable();
  }

  updateFavorites(propertyId: number, isFavFlag: number) {
    const api = (<any>_GlobalNS).api.property.updateFavoriteProperties;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, {'PropertyId': propertyId, 'IsFavorite': isFavFlag}, this.httpOptions);
  }

}